module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-debate_white.37dfcb8e.svg";